import { FormGroup } from "../../../components/form";
import * as Yup from "yup";

export const supportRequestedForm: FormGroup = {
  type: "formGroup",
  warn: "Please indicate the type of support you are requesting from the KIS program",
  fields: [
    {
      type: "field",
      key: "advisory",
      fieldType: "advisory",
      props: {
        type: "warning",
        Body: () => (
          <p className="list-none pl-2 m-0">
            If you are requesting specialist training or minor building modifications, you should upload two quotes where possible. If only one quote
            is uploaded, you must explain why a second quote could not be obtained.
            <br />
            Otherwise this may delay the processing of your application.
            <br />
            If you do not have these documents yet you can either wait until they are available to submit the application by saving the application,
            or submit without the quotes. If you choose to submit the application without quotes, make sure you don't tick the box/es in this section
            and then lodge an appeal at a later date, requesting these supports be considered.
          </p>
        ),
      },
    },
    {
      type: "field",
      fieldType: "checkbox",
      key: "specialistSupport",
      label: (
        <>
          <strong className="my-5 text-purple">Specialist consultancy</strong> support
        </>
      ),
    },
    {
      type: "field",
      key: "specialistSupportDesc",
      label:
        "What is the purpose of the specialist consultancy request, and how will it support the inclusion of the child in the kindergarten program?",
      extendedLabel: (
        <p className="list-none pl-2 m-0">
          Please describe the areas you would you like the specialist consultant to work on with your teaching team.
          <br />
          If you have been recommended specialist consultancy already this year, have you utilised this support? Please include this information and
          the outcomes of any previous support when describing your specialist consultancy request.
        </p>
      ),
      fieldType: "textarea",
      hideExpression: (formContext, values) => !values.specialistSupport,
      validation: Yup.string().trim().required("A response is required"),
    },
    {
      type: "field",
      fieldType: "checkbox",
      key: "additionalAssistant",
      label: (
        <>
          <strong>Additional Assistant</strong> to work as a member of the team to support the inclusion of all children in the group
        </>
      ),
    },
    {
      type: "field",
      key: "additionalAssitantDesc",
      label: "How will the additional assistant work with the kindergarten’s team to support the inclusion of all children in the group?",
      extendedLabel: (
        <p className="list-none pl-2 m-0">
          An additional assistant is intended to support the needs of the whole group and should not be working exclusively with an individual child.
          <br />
          If there is an Additional Assistant working with the group already, please consider this when describing why further additional assistant
          support is needed.
        </p>
      ),
      fieldType: "textarea",
      hideExpression: (formContext, values) => !values.additionalAssistant,
      validation: Yup.string().trim().required("A response is required"),
    },
    {
      type: "field",
      fieldType: "checkbox",
      key: "specialistTraining",
      label: (
        <>
          Funding for <strong>specialist training</strong> specific to supporting the needs of the child in this application
        </>
      ),
    },
    {
      type: "field",
      key: "specialistTrainingDesc",
      label:
        "What additional training (in addition to mandatory requirements for first aid, anaphylaxis management and asthma management training) is specifically required for the kindergarten team to support the needs of this child?",
      extendedLabel: (
        <p className="list-none pl-2 m-0">
          Specialist training must be organised in conjunction with your KIS provider if approved. The training requested must be specific for the
          needs of the child in the application, it should not be for generic training, or for training you would usually undertake as part of your
          professional development.
          <br />
          An example of the type of training you can apply for is someone to train your team in the management of a child's tracheostomy care, or the
          care and management of a child's epilepsy.
          <br />
          Two quotes for specialist training should be uploaded. If only one quote is uploaded, however, you must explain here why a second quote
          could not be obtained.
        </p>
      ),
      fieldType: "textarea",
      hideExpression: (formContext, values) => !values.specialistTraining,
      validation: Yup.string().trim().required("A response is required"),
    },
    {
      type: "field",
      fieldType: "checkbox",
      key: "buildingModifications",
      label: (
        <>
          Funding for <strong>minor building modifications</strong> specific to supporting the needs of the child in this application
        </>
      ),
    },
    {
      type: "field",
      key: "buildingModificationsDesc",
      label: "What minor building modifications are specifically required to support the needs of the child in this application?",
      extendedLabel: (
        <p className="list-none pl-2 m-0">
          Please describe the minor building modifications required to address the specific support needs of the child in this application.
          <br />
          Two quotes for minor building modifications should be uploaded. If only one quote is uploaded, you must explain here why a second quote
          could not be obtained.
        </p>
      ),
      fieldType: "textarea",
      hideExpression: (formContext, values) => !values.buildingModifications,
      validation: Yup.string().trim().required("A response is required"),
    },
    {
      type: "field",
      key: "atleastOne",
      fieldType: "error",
      validation: Yup.boolean().test("atleastOne", "A response is required", function () {
        const { additionalAssistant, buildingModifications, specialistTraining, specialistSupport } = this.parent;
        return additionalAssistant || buildingModifications || specialistTraining || specialistSupport;
      }),
    },
  ],
};
